// extracted by mini-css-extract-plugin
export default {"controls":"CaseSummaryControls_controls__vRB1f"};